module.exports = __webpack_public_path__ + "static/media/matche_active.ca85a979.svg";